import { cx, formatDate } from "~utils";
import styles from "./Kicker.module.css";

/**
 * @function Kicker
 * @typedef Props
 * @property {String} category article category
 * @property {String} display_date
 * @property {Boolean} isDarkMode
 * @property {String} release_date
 * @property {Boolean} showCategory some homepage modules (e.g. Podcasts) only show date
 * @property {Boolean} showPublishedDate some (e.g. LatestIssue) only show category
 * @property {String} subtype override `category` when rendering an Opinion article
 * @param {Props} props
 * @returns {React.JSX.Element}
 */

export const Kicker = ({
  className,
  category,
  custom_category,
  digital_column,
  display_date,
  isDarkMode = false,
  release_date,
  showCategory = true,
  showPublishedDate = true,
  sponsor_label = null,
  subtype,
}) => {
  // Use the display_date if available as that can be used by editorial to override dates; if display_date not there, try release_date, which is always present.
  // For games, we have date_published which is the same as release_date
  const publishedDate = display_date ? formatDate(display_date) : formatDate(release_date);

  let label = category;

  // special cases where we want to override the category field
  if (subtype === "opinion") {
    label = "Opinion";
  }
  if (digital_column) {
    label = digital_column;
  }
  if (subtype === "game" || category === "game") {
    label = "Games";
  }
  if (custom_category) {
    label = custom_category;
  }
  if (sponsor_label) {
    label = sponsor_label;
    showCategory = true;
  }

  return (
    <div className={cx(styles.kicker, className, isDarkMode && styles.isDarkMode)}>
      {showCategory && label}
      {showCategory && label && showPublishedDate && <span className={styles.kickerSpacer} />}
      {showPublishedDate && <span className={styles.kickerMeta}>{publishedDate}</span>}
    </div>
  );
};
